
import styles from "../styles/satisfaction-survey.module.scss";
export const NotFound = () => {
    return (
        <div className={styles.notFound}>
            <p className={styles.notFoundTitle}>
                Pedido não encontrado!
            </p>
            <p className={styles.notFoundMessage}>
                A URL acessada é inválida. Para avaliar seu pedido, acesse novamente o link enviado por SMS.
            </p>
        </div>
    )
}
